import React from 'react';
import { Typography } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';

type Props = {
  text?: string;
  subtext?: string;
};

const EmptyState = ({ text, subtext }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center">
      <img
        src="/static/icons/not-found-v2.svg"
        alt=""
        className="mb-4 h-[100px] w-[100px] sm:mb-6 sm:h-[150px] sm:w-[150px]"
      />
      <Typography className="text-center text-xl font-semibold text-neutral-primary">
        {text || t('no_teleconsultation_available')}
      </Typography>
      {!!subtext && (
        <Typography className="text-center text-neutral-secondary">
          {subtext}
        </Typography>
      )}
    </div>
  );
};

export default EmptyState;
